import {
  CashbackCodeAction,
  PromoType
} from "datalayer-service/src/types/enums";
import DataLayerService from "datalayer-service/src/datalayer";

const dataLayerService = new DataLayerService(window);

export function enableShowCodeButton() {
  // The enableShowCodeButton method could be called more than one time,
  // so this line unbind previous assignation of on click
  const showCodeBtn = $('[data-show-code]');

  showCodeBtn.off('click');
  showCodeBtn.on('click', function (e) {

    const $this = $(this);

    const promotion_id = $this.data('promotion');
    const outbound_url = $this.data('outboundUrl');
    const object_slug = $this.data('objectSlug');
    const object_classname = $this.data('objectClassname');
    const claimable = $this.data('claimable');
    const store = $this.data('storeSlug');
    const retailer = $this.data('retailerSlug');

    const urlSearchParams = new URLSearchParams(window.location.search);
    const source = urlSearchParams.get("ga");

    const cashbackInteractionEvent = {
      action: CashbackCodeAction.CLICK,
      retailerLocation: store,
      retailerName: retailer,
      source: source,
      pageRegion: $this.data('pageRegion'),
      type: claimable ? PromoType.LOCAL : PromoType.ONLINE,
    };

    dataLayerService.retailerCashbackCodeInterationEvent(cashbackInteractionEvent);

    if (claimable) {
      return;
    }

    e.preventDefault();

    let url = window.location.pathname;
    url = `${url}?show-promo-code=${promotion_id}&slug=${object_slug}&classname=${object_classname}&scrollY=${window.scrollY}`;
    url = `${url}${window.location.hash}`;

    dataLayerService.retailerCashbackCodeInterationEvent({
      ...cashbackInteractionEvent,
      action: CashbackCodeAction.VIEW,
      type: PromoType.ONLINE,
    });

    window.open(url);
    window.location.href = outbound_url;

  });

}
